export default {
  login: "Siddhant-K-code",
  id: 55068936,
  node_id: "MDQ6VXNlcjU1MDY4OTM2",
  avatar_url: "https://avatars0.githubusercontent.com/u/55068936?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/Siddhant-K-code",
  html_url: "https://github.com/Siddhant-K-code",
  followers_url: "https://api.github.com/users/Siddhant-K-code/followers",
  following_url:
    "https://api.github.com/users/Siddhant-K-code/following{/other_user}",
  gists_url: "https://api.github.com/users/Siddhant-K-code/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/Siddhant-K-code/starred{/owner}{/repo}",
  subscriptions_url:
    "https://api.github.com/users/Siddhant-K-code/subscriptions",
  organizations_url: "https://api.github.com/users/Siddhant-K-code/orgs",
  repos_url: "https://api.github.com/users/Siddhant-K-code/repos",
  events_url: "https://api.github.com/users/Siddhant-K-code/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/Siddhant-K-code/received_events",
  type: "User",
  site_admin: false,
  name: "Siddhant Khare",
  company: "GNCSGI",
  blog: "",
  location: "Jabalpur,India",
  email: null,
  hireable: true,
  bio:
    "Python, Angular Developer, Competitive Programmer. | AI/ML Enthu. | Web Designer/Dev.",
  twitter_username: "siddhant_says",
  public_repos: 127,
  public_gists: 2,
  followers: 19,
  following: 148,
  created_at: "2019-09-09T00:58:59Z",
  updated_at: "2020-08-10T16:22:35Z",
};
